// CRMOpenLead.js
import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import LeftNav from "../components/common/LeftNav";
import TopNav from "../components/common/TopNav";
import "bootstrap/dist/css/bootstrap.min.css";
import "../assets/styles/CRMOpenLead.css";
import callIcon from "../assets/img/call.svg";
import whatsappIcon from "../assets/img/whatsapp.svg";
import builderLogo from "../assets/img/builder.svg"; // dummy
import projectImg from "../assets/img/productimg.svg";
import bluecircle from "../assets/img/blue-circle.svg";
import leadleft from "../assets/img/lead-left.svg";
import leadlocation from "../assets/img/lead-location.svg";
import leadcalendar from "../assets/img/lead-calendar.svg";
import leaddown from "../assets/img/lead-down.svg";
import invoice from "../assets/img/invoice.svg";
import leadcircle from "../assets/img/lead-circle.svg";
import leadup from "../assets/img/up.svg";





export default function CRMOpenLead() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("Feedback");
  const [openIndex, setOpenIndex] = useState(0);

  const toggleInvoice = (i) => {
    setOpenIndex(openIndex === i ? null : i);
  };


  // Dummy lead data (replace with API later)
  const leadData = {
    id: id || "20250513",
    customer: {
      fullName: "Alexander Mitchell",
      email: "alexander.mitchell@gmail.com",
      phone: "+91 98765 43210",
      altPhone: "",
      address: "13th Street, New York, NY 10011, USA",
    },
    property: {
      type: "Apartment",
      bhk: "2 BHK",
      community: "Green Estates Residences",
      facing: "North",
      location: "Downtown, Financial District",
      area: [800, 4500],
      budget: [20, 400],
    },
    transport: ["Metro", "Bus Stop", "Highway"],
    leadMgmt: {
      status: "Yet to Contact",
      source: "Website",
      owner: "Assign To",
      projects: ["Sunset Villas", "Lakeside Residences"],
      created: "May 13, 2025 at 10:35 AM",
      modified: "May 15, 2025 at 12:35 PM",
    },
    builders: [
      { name: "ABC Builders", date: "May 6, 2025" },
      { name: "Surya Developers", date: "Apr 8, 2025" },
    ],
    projects: [
      { name: "Parkview Residences", location: "Jubilee Hills, Hyderabad", date: "May 6, 2025", img: projectImg },
      { name: "Parkview Residences", location: "Jubilee Hills, Hyderabad", date: "May 6, 2025", img: projectImg },
      { name: "Parkview Residences", location: "Jubilee Hills, Hyderabad", date: "May 6, 2025", img: projectImg },
    ],
    siteVisits: [
      {
        project: "Parkview Residences",
        builder: "Surya Developers",
        visited: "May 6, 2025, 10:35 AM",
      },
    ],
    tasks: [
      {
        title: "Follow-up Call",
        date: "May 20, 2025 at 2:30 PM",
        notes: "Discuss Lakeside Residences options and pricing",
      },
    ],
    invoices: [
      {
        customer: "Michael Thompson",
        phone: "+91 98765 43210",
        date: "May 6, 2025",
        builder: "Elemental Realty",
        stage: "Processing",
        status: "Accepted",
        commission: "1,17,000",
      },
    ],
    feedback: [
      {
        date: "May 13, 2025 at 10:35 AM",
        text: "Lead Created via website inquiry. Customer is looking for a 2 BHK apartment in Lakeside Residences with a budget of 4,50,000.",
      },
      {
        date: "May 15, 2025 at 10:35 AM",
        text: "Lead Updated via follow-up call.",
      },
    ],
    history: [
      { date: "May 13, 2025", text: "Lead Created" },
      { date: "May 15, 2025", text: "Status changed to Prospect, Added project." },
    ],
  };

  // Sliders state
  const [areaMin, setAreaMin] = useState(1200);
  const [areaMax, setAreaMax] = useState(2500);
  const [budgetMin, setBudgetMin] = useState(40);   // Lakhs
  const [budgetMax, setBudgetMax] = useState(120);  // Lakhs

  return (
    <div className="d-flex">
      <LeftNav />
      <div className="main-content flex-grow-1">
        <TopNav />
        <div className="p-3">
          <div className="crm-openlead-container p-4">

            {/* Lead ID + actions */}
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h5 className="lead-head"><img src={leadleft} className="me-2" alt="back" /> Lead ID : LD-{leadData.id}</h5>
              <div className="d-flex gap-3">
                <img src={callIcon} alt="call" width="36" height="36" />
                <img src={whatsappIcon} alt="whatsapp" width="36" height="36" />
              </div>
            </div>



            {/* CUSTOMER INFO */}
            <div className="crm-card mb-4 p-4">
              <h6 className="crm-section-title mb-4 ">Customer Information</h6>
              <div className="row">
                <div className="col mb-3">
                  <label className="form-label lead-label">Full Name</label>
                  <input className="form-control lead-input" value={leadData.customer.fullName} readOnly />
                </div>

              </div>
              <div className="row">
                <div className="col mb-3">
                  <label className="form-label lead-label">Email</label>
                  <input className="form-control lead-input" value={leadData.customer.email} readOnly />
                </div>
              </div>
              <div className="row">
                <div className="col-md-6 mb-3">
                  <label className="form-label lead-label">Phone</label>
                  <input className="form-control lead-input" value={leadData.customer.phone} readOnly />
                </div>
                <div className="col-md-6 mb-3">
                  <label className="form-label lead-label">Alternate Phone</label>
                  <input className="form-control lead-input" value={leadData.customer.altPhone} placeholder="Enter number" readOnly />
                </div>
              </div>
              <div>
                <label className="form-label lead-label">Address</label>
                <input className="form-control lead-input" value={leadData.customer.address} readOnly />
              </div>
            </div>

            {/* PROPERTY REQUIREMENTS */}
            <div className="crm-card mb-4 p-4">
              <h6 className="crm-section-title mb-3">Property Requirements</h6>

              {/* Property Type & BHK */}
              <div className="row mb-3">
                <div className="col-md-6">
                  <label className="form-label lead-label">Property Type</label>
                  <input className="form-control lead-input" value={leadData.property.type} readOnly />
                </div>
                <div className="col-md-6">
                  <label className="form-label lead-label">BHK</label>
                  <input className="form-control lead-input" value={leadData.property.bhk} readOnly />
                </div>
              </div>

              {/* Community */}
              <div className="mb-3">
                <label className="form-label lead-label">Community/Project</label>
                <input className="form-control lead-input" value={leadData.property.community} readOnly />
              </div>

              {/* Facing */}
              <div className="mb-3">
                <label className="form-label lead-label">Facing</label>
                <input className="form-control lead-input" value={leadData.property.facing} readOnly />
              </div>

              {/* Area Slider */}
              {/* Area Slider */}
              <div className="mb-4">
                <label className="form-label">Area (SFT)</label>
                <div className="slider-wrapper">
                  {/* Inputs */}
                  <input
                    type="range"
                    min="500"
                    max="10000"
                    step="500"
                    value={areaMin}
                    onChange={(e) =>
                      setAreaMin(Math.min(Number(e.target.value), areaMax - 500))
                    }
                    className="thumb"
                  />
                  <input
                    type="range"
                    min="500"
                    max="10000"
                    step="500"
                    value={areaMax}
                    onChange={(e) =>
                      setAreaMax(Math.max(Number(e.target.value), areaMin + 500))
                    }
                    className="thumb"
                  />

                  {/* Track + Range */}
                  <div className="slider">
                    <div className="track"></div>
                    <div
                      className="range purple"
                      style={{
                        left: `${((areaMin - 500) / (10000 - 500)) * 100}%`,
                        right: `${100 - ((areaMax - 500) / (10000 - 500)) * 100}%`,
                      }}
                    ></div>
                  </div>

                  {/* Labels */}
                  <div
                    className="thumb-label"
                    style={{ left: `${((areaMin - 500) / (10000 - 500)) * 100}%` }}
                  >
                    {areaMin}
                  </div>
                  <div
                    className="thumb-label"
                    style={{ left: `${((areaMax - 500) / (10000 - 500)) * 100}%` }}
                  >
                    {areaMax}
                  </div>

                  {/* Tick marks */}
                  <div className="ticks">
                    {Array.from({ length: 20 }).map((_, i) => (
                      <span key={i}></span>
                    ))}
                  </div>
                </div>
              </div>

              {/* Budget Slider */}
              <div className="mb-4">
                <label className="form-label">Budget</label>
                <div className="slider-wrapper">
                  <input
                    type="range"
                    min="10"
                    max="500"
                    step="10"
                    value={budgetMin}
                    onChange={(e) =>
                      setBudgetMin(Math.min(Number(e.target.value), budgetMax - 10))
                    }
                    className="thumb"
                  />
                  <input
                    type="range"
                    min="10"
                    max="500"
                    step="10"
                    value={budgetMax}
                    onChange={(e) =>
                      setBudgetMax(Math.max(Number(e.target.value), budgetMin + 10))
                    }
                    className="thumb"
                  />

                  {/* Track + Range */}
                  <div className="slider">
                    <div className="track"></div>
                    <div
                      className="range green"
                      style={{
                        left: `${((budgetMin - 10) / (500 - 10)) * 100}%`,
                        right: `${100 - ((budgetMax - 10) / (500 - 10)) * 100}%`,
                      }}
                    ></div>
                  </div>

                  {/* Labels */}
                  <div
                    className="thumb-label"
                    style={{ left: `${((budgetMin - 10) / (500 - 10)) * 100}%` }}
                  >
                    {budgetMin < 100 ? budgetMin + "L" : (budgetMin / 100).toFixed(2) + "Cr"}
                  </div>
                  <div
                    className="thumb-label"
                    style={{ left: `${((budgetMax - 10) / (500 - 10)) * 100}%` }}
                  >
                    {budgetMax < 100 ? budgetMax + "L" : (budgetMax / 100).toFixed(2) + "Cr"}
                  </div>

                  {/* Tick marks */}
                  <div className="ticks">
                    {Array.from({ length: 50 }).map((_, i) => (
                      <span key={i}></span>
                    ))}
                  </div>
                </div>
              </div>




              {/* Location */}
              <div>
                <label className="form-label lead-label">Location</label>
                <input className="form-control lead-input" value={leadData.property.location} readOnly />
              </div>
            </div>

            {/* LEAD MANAGEMENT */}
            <div className="crm-card mb-4 p-4">
              <h6 className="crm-section-title mb-3">Lead Management</h6>
              <div className="row">
                <div className="col-md-6 mb-3">
                  <label className="form-label lead-label">Lead Status</label>
                  <input className="form-control lead-input" value={leadData.leadMgmt.status} readOnly />
                </div>
                <div className="col-md-6 mb-3">
                  <label className="form-label lead-label">Lead Source</label>
                  <input className="form-control lead-input" value={leadData.leadMgmt.source} readOnly />
                </div>
              </div>
              <div className="mb-3">
                <label className="form-label lead-label">Lead Owner</label>
                <input className="form-control lead-input" value={leadData.leadMgmt.owner} readOnly />
              </div>
              <div className="mb-3">
                <label className="form-label lead-label">Interested Projects</label>
                <input className="form-control lead-input" value={leadData.leadMgmt.owner} readOnly />
                <div className="d-flex gap-2 mt-3 flex-wrap ">
                  {leadData.leadMgmt.projects.map((p, i) => (
                    <span key={i} className="badge interesested-badge ">
                      <span className="interesested-badgetext">{p} </span> <img src={bluecircle} alt="close" /></span>
                  ))}
                </div>
              </div>
              <small className="lead-label">Created: {leadData.leadMgmt.created}</small><br />
              <small className="lead-label mt-2">Last Modified: {leadData.leadMgmt.modified}</small>
            </div>

            <div className="crm-card mb-4 p-4">
              <h6 className="crm-section-title mb-3 px-2">Upcoming Tasks</h6>
              {leadData.tasks.map((t, i) => (
                <div key={i} className="upcoming-task-crm mb-2 px-3 py-1 ">
                  <div className="upcoming-task-title mt-2">{t.title}</div>
                  <div className="upcoming-task-text mt-3">{t.date}</div>
                  <div className="upcoming-task-text mt-3">{t.notes}</div>
                </div>
              ))}
            </div>
            {/* BUILDERS */}
            <div className="crm-card mb-4 p-4">
              <h6 className="crm-section-title mb-3">Registered Builders</h6>
              {leadData.builders.map((b, i) => (
                <div key={i} className="d-flex justify-content-between align-items-center mt-2 py-2">
                  <div className="d-flex align-items-center gap-2">
                    <img src={builderLogo} alt="builder" width="48" height="48" />
                    <span className="crm-register-name">{b.name}</span>
                  </div>
                  <small className="crm-register-date">{b.date}</small>
                </div>
              ))}
            </div>

            {/* PROJECTS */}
            <div className="crm-card mb-4 p-3">
              <h6 className="crm-section-title mb-4">Registered Projects</h6>
              <div className="row custom-gap">
                {leadData.projects.map((p, i) => (
                  <div key={i} className="col-md-4">
                    <div className="card h-100 project-card">
                      <img src={p.img} className="card-img-top project-img" alt={p.name} />
                      <div className="card-body text-start">
                        <div className="lead-project-name">{p.name}</div>
                        <div className="lead-project-date mt-2 d-flex align-items-center">
                          <img src={leadlocation} alt="locate" width={14} height={14} className="me-1" />
                          <span>{p.location}</span>
                        </div>

                        <div className="lead-project-location mt-3">{p.date}</div>
                      </div>

                    </div>
                  </div>
                ))}
              </div>
            </div>


            {/* SITE VISITS */}
            <div className="crm-card mb-4 p-4">
              <h6 className="crm-section-title">Site Visit Logs</h6>
              {leadData.siteVisits.map((v, i) => (
                <div key={i} className="mb-2 mt-2">
                  <div className="site-project mt-4">Project: {v.project}</div>
                  <div className="site-project mt-3">Builder: {v.builder}</div>
                  <div className="site-project mt-3">Visited Date: {v.visited}</div>
                </div>
              ))}
            </div>
            <div className="text-end  mt-3 mb-3">
              <button className="generate-invoicebtn">
                <span className="generate-invoicetext d-flex  justify-content-center">Generate Invoice</span>
              </button>

            </div>

            {/* TASKS */}


            {/* INVOICES */}
            <div className="crm-card mb-4 px-4  p-2">


              {leadData.invoices.map((inv, i) => (
                <div key={i} >
                  {/* Top Row */}
                  <div className="d-flex justify-content-between align-items-center mt-2">
                    <div>
                      <div className="invoice-name">{inv.customer}</div>
                      <div className="invoice-label text-start mt-2">{inv.phone}</div>
                      <div className="invoice-label mt-2">Invoice Date: {inv.date}</div>

                    </div>

                    <div className="d-flex align-items-center">
                      {/* Download button */}
                      <button className="btn btn-link text-pink me-2">
                        <img src={invoice} size={20} />
                      </button>

                      {/* Toggle expand/collapse */}
                      <button
                        className="btn btn-link"
                        onClick={() => toggleInvoice(i)}
                      >
                        {openIndex === i ? (
                          <img src={leadup} size={16} />
                        ) : (
                          <img src={leaddown} size={16} />
                        )}
                      </button>
                    </div>
                  </div>

                  {/* Divider */}
                  {openIndex === i && <hr />}
                  {openIndex === i && (
                    <div>
                      <div>
                        <span className="builder-text">Builder:</span> <span className="builder-label">{inv.builder}</span>
                      </div>
                      <div>
                        <span className="builder-text">Invoice Stage:</span> <span className="builder-label">{inv.stage}</span>
                      </div>
                      <div>
                        <span className="builder-text" >Commission Amount:</span> <span className="builder-label"> {inv.commission}</span>
                      </div>

                    </div>
                  )}
                </div>
              ))}

            </div>

           {/* FEEDBACK & HISTORY */}
<div className="crm-card mb-4 p-4">
  <h6 className="crm-section-title">Feedback & History</h6>

  {/* Textarea + Button inline */}
  <div className="lead-feedbacktext mt-4 mb-2">Add Feedback</div>
  <div className="d-flex gap-3 align-items-start mb-3">
    <textarea
      className="form-control"
      rows="3"
      placeholder="Enter feedback here"
      style={{ flex: 1 }}
    ></textarea>
   
  </div>
  <div className="text-end mb-3 ">
   <button className="submit-feedback">
   <span className="submit-feedbacktext"> Submit Feedback</span>
    </button>
   </div>

  {/* Tabs */}
  <div className="d-flex justify-content-center gap-3 mb-4 mt-4">
    <button
      className={`feedback-tab1 ${activeTab === "Feedback" ? "active" : ""}`}
      onClick={() => setActiveTab("Feedback")}
    >
      <span className="feedback-tab1text">Feedback</span>
    </button>
    <button
      className={`feedback-tab2 ${activeTab === "History" ? "active" : ""}`}
      onClick={() => setActiveTab("History")}
    >
       <span className="feedback-tab2text"> Lead History</span>
     
    </button>
  </div>

 {/* Entries */}
{activeTab === "Feedback"
  ? leadData.feedback.map((f, i) => (
      <div key={i} className="feedback-entry mb-3 p-3 ">
        <div className="feedback-date-crm">{f.date}</div>
        <div className="feedback-text-crm mt-2">{f.text}</div>
      </div>
    ))
  : leadData.history.map((h, i) => (
      <div key={i} className="feedback-entry mb-3 p-3">
        <div className="feedback-date-crm">{h.date}</div>
        <div className="feedback-text-crm">{h.text}</div>
      </div>
    ))}

</div>


            {/* ACTION BUTTONS */}
            <div className="d-flex justify-content-end gap-2">
              <button className="btn btn-outline-danger">Delete</button>
              <button className="btn btn-primary">Save</button>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
}
